var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Select } from '@bfa/base-ui';
import { Flex, FlexItem, Text } from '@bfa/common-ui';
import React, { useState } from 'react';
import AddItemButton from '../../../../../../../components/AddItemButton';
import { NBProductSubscriptionType } from '../../../../../../../types/enums';
import { formatPriceAsWholeNumber, getProductSellingOptions, getShipmentFrequencyOption, SHIPMENT_FREQUENCIES, } from '../../../../../../../utils/subscription';
var ProductUpsell = function (_a) {
    var _b;
    var product = _a.product, productModalContent = _a.productModalContent, onSubscribe = _a.onSubscribe, onAddAsOneOff = _a.onAddAsOneOff, _c = _a.showSubscribeCtaFeedback, showSubscribeCtaFeedback = _c === void 0 ? false : _c, _d = _a.showOneOffCtaFeedback, showOneOffCtaFeedback = _d === void 0 ? false : _d;
    var _e = getProductSellingOptions(product), canSubscribe = _e.canSubscribe, canOneOff = _e.canOneOff, isOnlyOneOff = _e.isOnlyOneOff;
    var isKit = product.subscriptionType === NBProductSubscriptionType.KIT;
    var defaultFrequency = getShipmentFrequencyOption((_b = product.defaultCadenceInMonths) === null || _b === void 0 ? void 0 : _b.toString());
    var _f = __read(useState(defaultFrequency), 2), frequency = _f[0], setFrequency = _f[1];
    var _g = productModalContent || {}, subscribeButtonText = _g.subscribeButtonText, oneOffButtonText = _g.oneOffButtonText, loadingButtonText = _g.loadingButtonText, cadenceDropdownLabel = _g.cadenceDropdownLabel;
    var subscribeCtaText = "".concat(subscribeButtonText, " - ").concat(formatPriceAsWholeNumber(product.price));
    var oneOffCtaTextWithPrice = "".concat(oneOffButtonText, " - ").concat(formatPriceAsWholeNumber(product.oneOffPrice));
    return (React.createElement(React.Fragment, null,
        canSubscribe && (React.createElement(React.Fragment, null,
            !isKit && (React.createElement(Flex, { mb: "2rem", flexDirection: "row", alignItems: "center" },
                React.createElement(FlexItem, { flex: "1" },
                    React.createElement(Text, { bold: true }, cadenceDropdownLabel)),
                React.createElement(FlexItem, { flex: "1", maxWidth: "13rem" },
                    React.createElement(Select, { id: "change-frequency-dropdown", items: SHIPMENT_FREQUENCIES, onBlur: function () { return null; }, onChange: function (value) {
                            return setFrequency(getShipmentFrequencyOption(value));
                        }, placeholder: frequency === null || frequency === void 0 ? void 0 : frequency.title, touched: true })))),
            React.createElement(AddItemButton, { primaryCta: subscribeCtaText, secondaryCta: loadingButtonText, showSecondaryCta: showSubscribeCtaFeedback, onClick: function () { return onSubscribe(product, parseInt(frequency === null || frequency === void 0 ? void 0 : frequency.value, 10)); }, main: true, small: true }))),
        canOneOff && (React.createElement(AddItemButton, { primaryCta: oneOffCtaTextWithPrice, secondaryCta: loadingButtonText, showSecondaryCta: showOneOffCtaFeedback, onClick: function () { return onAddAsOneOff(product); }, main: isOnlyOneOff, small: true }))));
};
export default ProductUpsell;
